import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { FormsValidationErrorsTextService } from '@core/services/forms-validation-errors-text.service';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[cassErrorForFormControlName]'
})
export class ErrorForFormControlNameDirective implements OnInit, OnDestroy {

	controlName?: string;
	formControl?: AbstractControl;
	formGroup?: FormGroup;
	subs?: Subscription;

	@Input()
	set cassErrorForFormControlName(value: string | undefined) {
		if (value) {
			this.controlName = value;
			this.initDirective();
		}
	}

	constructor (private elemRef: ElementRef, private validationErrorsTextService: FormsValidationErrorsTextService, private formGroupDirective: FormGroupDirective) {
	}

	ngOnInit(): void {
		if (this.formGroupDirective && this.formGroupDirective.form) {
			this.formGroup = this.formGroupDirective.form;
			this.initDirective();
		}
		else {
			console.warn("ErrorForFormControlNameDirective: the form cannot be accessed, the errors will not be displayed.");
		}
	}

	ngOnDestroy() {
		this.subs?.unsubscribe();
	}

	private initDirective(): void {
		if (!this.formControl && this.controlName && this.formGroup) {
			this.formControl = this.formGroup?.controls[this.controlName];

			if (this.formControl) {
				this.subs = this.formControl.statusChanges.subscribe(async () => {
					this.updateErrorMessage();
				});

				if (this.formControl.errors) {
					this.updateErrorMessage();
				}
			}
			else {
				// TBD: report error, fatal
			}
		}
	}

	private async updateErrorMessage() {
		if (this.formControl?.invalid) {
			if (this.elemRef) {
				this.elemRef.nativeElement.innerHTML = (await this.validationErrorsTextService.getText(this.formControl.errors)) || "Unknown error";
			}

			if (!this.formControl.touched) {
				if (this.formControl.errors && (this.formControl.errors['maxlength'] || this.formControl.errors['minlength'] || this.formControl.errors['cassMaxContentSize'])) {
					// make the mat-error reveal itself even if the control is untouched
					this.formControl.markAsTouched();
				}
			}
		}
	}
}


